'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

var _HtmlUtils = require('../../../HtmlUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QUICK_REACTIONS = ["👍", "👎", "😄", "🎉", "😕", "❤️", "🚀", "👀"].map(function (emoji) {
    var data = (0, _HtmlUtils.findEmojiData)(emoji);
    if (!data) {
        throw new Error('Emoji ' + emoji + ' doesn\'t exist in emojibase');
    }
    // Prefer our unicode value for quick reactions (which does not have
    // variation selectors).
    return (0, _assign2.default)({}, data, { unicode: emoji });
}); /*
    Copyright 2019 Tulir Asokan <tulir@maunium.net>
    
    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at
    
        http://www.apache.org/licenses/LICENSE-2.0
    
    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
    */

var QuickReactions = function (_React$Component) {
    (0, _inherits3.default)(QuickReactions, _React$Component);

    function QuickReactions(props) {
        (0, _classCallCheck3.default)(this, QuickReactions);

        var _this = (0, _possibleConstructorReturn3.default)(this, (QuickReactions.__proto__ || (0, _getPrototypeOf2.default)(QuickReactions)).call(this, props));

        _this.state = {
            hover: null
        };
        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(QuickReactions, [{
        key: 'onMouseEnter',
        value: function onMouseEnter(emoji) {
            this.setState({
                hover: emoji
            });
        }
    }, {
        key: 'onMouseLeave',
        value: function onMouseLeave() {
            this.setState({
                hover: null
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var Emoji = _index2.default.getComponent("emojipicker.Emoji");

            return _react2.default.createElement(
                'section',
                { className: 'mx_EmojiPicker_footer mx_EmojiPicker_quick mx_EmojiPicker_category' },
                _react2.default.createElement(
                    'h2',
                    { className: 'mx_EmojiPicker_quick_header mx_EmojiPicker_category_label' },
                    !this.state.hover ? (0, _languageHandler._t)("Quick Reactions") : _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                            'span',
                            { className: 'mx_EmojiPicker_name' },
                            this.state.hover.annotation
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'mx_EmojiPicker_shortcode' },
                            this.state.hover.shortcodes[0]
                        )
                    )
                ),
                _react2.default.createElement(
                    'ul',
                    { className: 'mx_EmojiPicker_list' },
                    QUICK_REACTIONS.map(function (emoji) {
                        return _react2.default.createElement(Emoji, {
                            key: emoji.hexcode, emoji: emoji, onClick: _this2.props.onClick,
                            onMouseEnter: _this2.onMouseEnter, onMouseLeave: _this2.onMouseLeave,
                            selectedEmojis: _this2.props.selectedEmojis });
                    })
                )
            );
        }
    }]);
    return QuickReactions;
}(_react2.default.Component);

QuickReactions.propTypes = {
    onClick: _propTypes2.default.func.isRequired,
    selectedEmojis: _propTypes2.default.instanceOf(_set2.default)
};
exports.default = QuickReactions;
module.exports = exports['default'];
//# sourceMappingURL=QuickReactions.js.map